module.exports = __webpack_public_path__ + "img/icon_home.edc26cc1.jpg";